/**
 * Stops pinch, trackpad and keyboard (Ctrl/Cmd + plus, minus, 0) zoom on every page.
 * Safari ignores user-scalable=no in the viewport tag, so gestures are also blocked here.
 */
const stop = (event) => event.preventDefault();
document.addEventListener('gesturestart', stop, { passive: false });
document.addEventListener('gesturechange', stop, { passive: false });
document.addEventListener('gestureend', stop, { passive: false });
document.addEventListener('touchmove', (event) => {
  if (event.touches.length > 1 || (event.scale && event.scale !== 1)) event.preventDefault();
}, { passive: false });
document.addEventListener('wheel', (event) => {
  if (event.ctrlKey || event.metaKey) event.preventDefault();
}, { passive: false });
document.addEventListener('keydown', (event) => {
  if (!(event.ctrlKey || event.metaKey)) return;
  if (['+', '=', '-', '_', '0'].includes(event.key) || ['Equal', 'Minus', 'Digit0', 'NumpadAdd', 'NumpadSubtract', 'Numpad0'].includes(event.code)) {
    event.preventDefault();
  }
});
